/**
 *
 * getUserEmail is to be used to get user email specifically for display and transactional email services.
 * This is not to be used for the user email as a unique identifier
 * @param {Object} user -
 * @returns {string} a user email
 */
const getUserEmail = user => user.email

module.exports = { getUserEmail }
